import { useEffect, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { login, logout, clearError } from '@/store/slices/authSlice';
import { useShopInfo } from './useShopInfo';

export function useAuth() {
  const dispatch = useAppDispatch();
  const { shopId, idToken } = useShopInfo();

  const { isAuthenticated, isLoading, error, accessToken, shop } = useAppSelector(
    (state) => state.auth
  );

  const authenticate = useCallback(async () => {
    if (!shopId || !idToken) {
      return;
    }

    try {
      await dispatch(login({ shopId, idToken })).unwrap();
    } catch (err) {
      console.error('Authentication failed:', err);
    }
  }, [shopId, idToken, dispatch]);

  useEffect(() => {
    if (isAuthenticated) return;

    if (isLoading && shopId && idToken) {
      authenticate();
    }
  }, [authenticate, isAuthenticated, isLoading, shopId, idToken]);

  const handleLogout = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  const handleClearError = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  return {
    isAuthenticated,
    isLoading,
    error,
    accessToken,
    shop,
    logout: handleLogout,
    clearError: handleClearError,
    retry: authenticate,
  };
}
